<template>
  <div class="w-full max-w-lg mx-auto">
    <form class="w-full" @submit.prevent="submit" v-if="!invalid">
      <p
        class="text-center mb-2"
      >You may request an email to reset your password. Please enter your account's email to continue.</p>

      <div class="w-full mb-2 px-2">
        <nx-input
          v-model="email"
          :errors="form.errors"
          placeholder="tassadar@aiur.com"
          id="email"
          type="email"
          label="Your Email"
          maxlength="255"
          :focus="true"
        />
      </div>

      <div class="flex flex-wrap w-full mb-2">
        <div class="w-1/2 mb-2 px-2 md:mb-0">
          <nx-input
            v-model="password"
            :errors="form.errors"
            placeholder="3nT4roAdun"
            id="password"
            type="password"
            label="Password"
            minlength="8"
            maxlength="30"
          />
        </div>

        <div class="w-1/2 px-2">
          <nx-input
            v-model="password_confirmation"
            :errors="form.errors"
            placeholder="3nT4roAdun"
            id="password_confirmation"
            type="password"
            label="Password Confirmation"
            minlength="8"
            maxlength="30"
          />
        </div>

        <p
          v-if="!form.errors.has('password')"
          class="text-sm mt-1 px-2 text-blue"
        >Must be at least 8 characters long and include lowercase, uppercase and numbers.</p>
      </div>

      <div class="w-full text-center">
        <nx-button
          native-type="submit"
          type="primary"
          :disabled="loading"
        >{{ loading ? 'Loading..' : 'Reset' }}</nx-button>
      </div>
    </form>

    <p v-else class="w-full text-center">
      The token provided is either invalid or expired. Please try
      <router-link
        :to="{name: 'password.email'}"
        class="text-blue-7 hover:text-blue-5"
      >requesting a new email</router-link>.
    </p>
  </div>
</template>

<script>
import Form from "form-backend-validation"
import { EventBus } from "@/events"

export default {
  name: "ResetPasswordForm",
  data() {
    return {
      form: new Form(),
      token: "",
      email: "",
      password: "",
      password_confirmation: "",
      success: false,
      loading: false,
      invalid: false
    }
  },
  methods: {
    async submit() {
      this.loading = true
      await this.$api.auth
        .resetPassword({
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        .then(() => {
          EventBus.$emit("login:show")
          this.$toasted.success("Your password has been updated.")
          this.$router.push({ name: "channels.index" })
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            if (data.response.data.errors.token) {
              this.invalid = true
            } else if (data.response && data.response.status === 422) {
              this.form.onFail(data)
              this.$error.form()
            } else {
              this.$error.generic()
            }
          }
        })
      this.loading = false
    }
  },
  created() {
    this.token = this.$route.params.token
  }
}
</script>

